export default "<div class=\"adhoc-checkbox text-align-center line-height-35\" (click)=\"deleteRow()\">\n    <em class=\"ld-icon-dismiss\"></em>\n</div>\n"